import { IClassname } from '@/lib/shared/model/classname';

export const MapPinIcon = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 11.9948C12.104 11.9948 13 11.0993 13 9.99606C13 8.89278 12.104 7.99738 11 7.99738C9.896 7.99738 9 8.89278 9 9.99606C9 11.0993 9.896 11.9948 11 11.9948Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 9.99606C17 14.9928 12 17.9909 11 17.9909C10 17.9909 5 14.9928 5 9.99606C5 6.68522 7.687 4 11 4C14.313 4 17 6.68522 17 9.99606Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="square"
      />
    </svg>
  );
};
